// src/AirplaneLandingAirstrip.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirplaneLandingAirstrip_default = createIcon({
  displayName: "AirplaneLandingAirstrip",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M11.0996 3.00011C10.506 3.00615 10 3.49167 10 4.1173V10.7462L5.08398 9.45128L4.39648 7.59972C4.31148 7.37272 4.11786 7.20255 3.88086 7.14855C3.43086 7.04555 3 7.38867 3 7.85167V10.463C3 11.37 3.61128 12.1646 4.48828 12.3966L19.1484 16.2833V16.2794C19.2635 16.3076 19.3815 16.322 19.5 16.3224C20.3284 16.3224 21 15.6508 21 14.8224C20.9998 14.1033 20.4894 13.4855 19.7832 13.3497L14.7891 12.0138L12.1777 3.77941C12.0577 3.40141 11.7464 3.11445 11.3594 3.02745C11.2723 3.00783 11.1844 2.99925 11.0996 3.00011ZM4 19.3224C3.448 19.3224 3 19.7704 3 20.3224C3 20.8744 3.448 21.3224 4 21.3224H20C20.552 21.3224 21 20.8744 21 20.3224C21 19.7704 20.552 19.3224 20 19.3224H4Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  AirplaneLandingAirstrip_default
};
